import axios from "axios";

export const fetchTransferIdDetails = async () => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PROXY_URL}/v1/transferId/fetch`,
      null,
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
      },
    );
    return response.data;
  } catch (e) {
    return null;
  }
};
